import React, { useEffect, useRef } from 'react';
import PhotoUpload from 'components/PhotoUpload';
import { ESTADO_FILA } from 'lib/estadoUi';
import BotonesEstado from './BotonesEstado';
import ElegirArboles, { ElegirLineas } from './ElegirArboles';
import { CAMPO_TEXTO, esHallazgo } from './comun';

// Un paso por ítem del checklist. Alerta o Falla abren aquí mismo el
// comentario obligatorio y las fotos del hallazgo. En una Falla la foto
// también es obligatoria (el resumen no deja guardar sin ella).
// arboles: en el ítem fitosanitario, la lista de árboles de la instalación
// (null en los demás ítems). Con hallazgo se pide cuál árbol, debajo de la nota.
// lineas: igual, en "Estado del cable" y "Punto de anclaje" (cuál cable).
export default function PasoItem({
  item, seccion, valor, detalle, onMarcar, onNota, onFotos,
  confirmando = false, onConfirmarAprobado, onCancelarAprobado,
  arboles = null, onArboles, lineas = null, onLineas,
}) {
  const elegidasLineas = detalle?.lineas || [];
  const notaRef = useRef(null);
  const cancelarRef = useRef(null);
  const enfocarRef = useRef(false);
  const hallazgo = esHallazgo(valor);
  const nota = detalle?.nota || '';
  const idNota = `nota-${item.key}`;
  const esFalla = valor === 'falla';
  const nFotos = (detalle?.fotoBlobs || []).length;
  const elegidos = detalle?.arboles || [];

  // Al pasar de "sin hallazgo" a Alerta o Falla se lleva el foco al comentario
  // (es obligatorio). Al volver al paso con la nota ya escrita, no.
  const marcar = (v) => {
    enfocarRef.current = esHallazgo(v) && !hallazgo;
    onMarcar(v);
  };
  useEffect(() => {
    if (enfocarRef.current && notaRef.current) {
      enfocarRef.current = false;
      notaRef.current.focus();
    }
  }, [valor]);

  // El diálogo de confirmación recibe el foco (lectores de pantalla y teclado).
  useEffect(() => {
    if (confirmando) cancelarRef.current?.focus();
  }, [confirmando]);

  let ayuda;
  if (!nota.trim()) ayuda = esFalla ? 'Obligatorio: describa la falla y tome al menos una foto.' : 'Obligatorio para continuar.';
  else if (esFalla && nFotos === 0) ayuda = 'Falta la foto: en una Falla es obligatoria.';
  else ayuda = 'Puede agregar más fotos del hallazgo.';

  return (
    <div>
      <p className="text-sm font-bold uppercase tracking-wide text-primary">{seccion}</p>
      <h2 tabIndex={-1} className="mt-1 text-2xl font-bold leading-tight text-foreground focus:outline-none">
        {item.label}
      </h2>
      <p className="mt-2 text-base leading-snug text-foreground">{item.descripcion}</p>

      <div className="mt-5">
        <BotonesEstado valor={valor} onMarcar={marcar} />
      </div>
      {!valor && (
        <p data-sin-marcar className="mt-3 text-base font-semibold text-foreground">
          Sin marcar: elija Aprobado, Alerta o Falla para seguir.
        </p>
      )}

      {confirmando && (
        <div
          role="alertdialog"
          aria-label="Confirmar Aprobado"
          className="mt-4 rounded-2xl border-2 border-foreground/30 bg-card p-4 shadow-card"
        >
          <p className="text-base font-semibold text-foreground">
            Este ítem tiene una nota o fotos. Si lo marca Aprobado se quitan.
          </p>
          <div className="mt-3 flex gap-3">
            <button
              ref={cancelarRef}
              type="button"
              onClick={onCancelarAprobado}
              className="min-h-[48px] flex-1 rounded-xl border-2 border-border bg-white px-3 text-base font-semibold text-foreground"
            >
              Cancelar
            </button>
            <button
              type="button"
              onClick={onConfirmarAprobado}
              className="min-h-[48px] flex-1 rounded-xl bg-foreground px-3 text-base font-semibold text-white"
            >
              Quitar nota y fotos
            </button>
          </div>
        </div>
      )}

      {hallazgo && (
        <div className={`mt-5 rounded-2xl p-4 ring-1 ring-border ${ESTADO_FILA[valor]}`}>
          <label htmlFor={idNota} className="block text-base font-semibold text-foreground">
            Describa el hallazgo
          </label>
          <p id={`${idNota}-ayuda`} className="mt-0.5 text-sm font-semibold text-foreground">
            {ayuda}
          </p>
          <textarea
            id={idNota}
            ref={notaRef}
            rows={3}
            value={nota}
            onChange={(e) => onNota(e.target.value)}
            aria-describedby={`${idNota}-ayuda`}
            aria-required="true"
            className={`mt-2 ${CAMPO_TEXTO}`}
          />
          {arboles && (arboles.length > 0 || elegidos.length > 0) ? (
            <ElegirArboles
              arboles={arboles}
              elegidos={elegidos}
              onCambiar={onArboles}
              obligatorio={arboles.length > 0}
              idBase={idNota}
            />
          ) : null}
          {lineas && (lineas.length > 0 || elegidasLineas.length > 0) ? (
            <ElegirLineas
              lineas={lineas}
              elegidos={elegidasLineas}
              onCambiar={onLineas}
              obligatorio={lineas.length > 0}
              idBase={idNota}
            />
          ) : null}
          <div className="mt-3">
            <PhotoUpload value={detalle?.fotoBlobs || []} onChange={onFotos} />
          </div>
        </div>
      )}
    </div>
  );
}
